import { useSelector } from 'react-redux';
import { Api, apiFactory } from 'model/services/Api/Api';

export const useApi = (): Api => {
	return useSelector(apiFactory);
}
